export default {
      id: "america-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "img/icons.svg#america",
      toString: function () {
        return this.url;
      }
    }